import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import './Result.css';
import config from '../../config';

function Answers() {
    const { assessmentId, id } = useParams(); // _id is now a query parameter
    const [questionAnswers, setQuestionAnswers] = useState([]);
    const location = useLocation();
    const _id = new URLSearchParams(location.search).get('_id');

    useEffect(() => {
        if (_id) {
            fetch(`${config.env.API_BASE_URL}/api/results/${assessmentId}/answers?_id=${_id}`, {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            })
                .then(response => response.json())
                .then(data => setQuestionAnswers(data))
                .catch(error => console.error('Error fetching answers:', error));
        } else {
            console.error('No _id provided');
        }
    }, [assessmentId, _id]);

    return (
        <div>
            <div className='mt-5 Crud-main-container container'>
                <table className="table Crud-main container">
                    <thead>
                        <tr className="Crud-thead-wrapper">
                            <th scope="col" className='text-start'>Question</th>
                            <th scope="col">Answer</th>
                        </tr>
                    </thead>
                    <tbody>
                        {questionAnswers.map((qa, index) => (
                            <tr key={index}>
                                <td className='text-start'>{qa.question}</td>
                                <td>{
                                    qa.type == 'File' ? 
                                    <td>
                                        {
                                            qa.answer.split(',').map((str, index) => { 
                                                return <><a href={config.env.STORAGE_URL + str} target='_blank'>{str}</a><br /></>
                                            })
                                        }
                                            
                                    </td> : <td>{qa.answer}</td>
                                }</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Answers;
